import React, { PropsWithChildren } from 'react';

/**
 * Table Body Slot
 */
export default function Body({ children }: PropsWithChildren<{}>) {
  return <>{children}</>;
}
